import React from "react";
import { Button, Stack, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const BRAND_GREEN = "#648315";

export default function HelpChatInput({ value, onChange, onSend, disabled }) {
  const handleInputKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      onSend();
    }
  };

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
      <TextField
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={handleInputKeyDown}
        placeholder="Ask a question..."
        multiline
        minRows={2}
        maxRows={4}
        fullWidth
        disabled={disabled}
        autoFocus
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            backgroundColor: "#fff",
          },
        }}
      />
      <Button
        variant="contained"
        endIcon={<SendIcon />}
        onClick={() => onSend()}
        disabled={!value.trim() || disabled}
        sx={{
          minWidth: { xs: "100%", sm: 112 },
          alignSelf: { xs: "stretch", sm: "flex-start" },
          minHeight: 54,
          color: "#fff",
          backgroundColor: BRAND_GREEN,
          fontWeight: 900,
          textTransform: "none",
          borderRadius: 2,
          "&:hover": {
            backgroundColor: "#526f12",
          },
        }}
      >
        Send
      </Button>
    </Stack>
  );
}
